import { FC, useEffect } from 'react'
import Footer from './Footer'
import ScrollButton from './ScrollButton'
import { Outlet, useLocation } from 'react-router-dom'
import animation from '../helpers/animation'
import Navbar from '../components/Navbar/Navbar'
import BurgerRain from '../components/BurgerRain/BurgerRain'

const Layout: FC = () => {
   let { pathname } = useLocation()
   useEffect(() => animation(), [pathname])

   return (
      <>
         {pathname === '/' && <BurgerRain />}
         <Navbar />
         <main>
            <Outlet />
            <ScrollButton />
         </main>
         <Footer />
      </>
   )
}

export default Layout
